import { ApiOutlined, CodeOutlined, RocketOutlined } from "@ant-design/icons";
import { Card, Space, Tag, Typography } from "antd";

const { Title, Paragraph, Link, Text } = Typography;

export default function About() {
  // Dynamische Swagger URL basierend auf Environment
  const getSwaggerUrl = () => {
    const apiUrl = import.meta.env.VITE_API_URL || "/api";

    // Wenn API URL relativ ist (/api), verwende aktuelle Domain
    if (apiUrl.startsWith("/")) {
      return `${window.location.origin}/swagger-ui`;
    }

    // Ansonsten ersetze /api mit /swagger-ui
    return apiUrl.replace("/api", "/swagger-ui");
  };

  return (
    <Space direction="vertical" size="large" style={{ width: "100%", maxWidth: 800 }}>
      <Card>
        <Title level={2}>
          <RocketOutlined /> Über dieses Template
        </Title>
        <Paragraph>
          Dieses Template nutzt <strong>React + Vite + Flask + Marshmallow </strong> als modernen
          Starter für Fullstack-Projekte mit Multi-Environment Docker-Unterstützung.
          <br />
          Es wird als UI Component Kit das <strong>Ant Design</strong> verwendet.
          <br />
          Dieses Template nutzt <strong>Modern Tools</strong>: <strong>Biome</strong> (Rust) für
          Frontend-Linting und <strong>Ruff</strong> (Rust) für Backend-Linting und Formatting.
        </Paragraph>
      </Card>

      <Card
        title={
          <>
            <CodeOutlined /> Frontend Stack
          </>
        }
      >
        <ul>
          <li>
            <strong>Vite 5</strong> - Lightning-fast Build-Tool
          </li>
          <li>
            <strong>React 18</strong> - UI Library mit Hooks
          </li>
          <li>
            <strong>React Router 6</strong> - Client-side Routing
          </li>
          <li>
            <strong>Ant Design 5</strong> - Enterprise UI Components
          </li>
          <li>
            <strong>Biome</strong> - Linting & Formatting (Rust)
          </li>
          <li>
            <strong>Vitest</strong> - Unit Testing
          </li>
          <li>
            <strong>npm</strong> - Package Manager
          </li>
        </ul>
      </Card>

      <Card
        title={
          <>
            <ApiOutlined /> Backend Stack
          </>
        }
      >
        <ul>
          <li>
            <strong>Flask 3</strong> - Python Web Framework
          </li>
          <li>
            <strong>SQLAlchemy</strong> - ORM & Database
          </li>
          <li>
            <strong>Flask-Smorest</strong> - REST API mit OpenAPI
          </li>
          <li>
            <strong>Marshmallow</strong> - Schema Validation
          </li>
          <li>
            <strong>Flask-Migrate</strong> - Database Migrations
          </li>
          <li>
            <strong>Gunicorn</strong> - Production WSGI Server
          </li>
          <li>
            <strong>Ruff</strong> - Linting & Formatting (Rust)
          </li>
          <li>
            <strong>pytest</strong> - Testing Framework
          </li>
          <li>
            <strong>Mamba/Conda</strong> - Package & Environment Manager
          </li>
        </ul>
      </Card>

      <Card title="🐳 Multi-Environment Setup with Multi-Stage Docker Build">
        <Space direction="vertical" size="middle" style={{ width: "100%" }}>
          <div>
            <Tag color="blue">local</Tag>
            <Text strong> Local Development</Text>
            <Paragraph style={{ marginTop: 8 }}>
              • Flask Dev Server + Vite HMR
              <br />• Schnelle lokale Entwicklung ohne Docker
              <br />• http://localhost:5173 (Frontend)
              <br />• http://localhost:5000 (Backend)
            </Paragraph>
          </div>

          <div>
            <Tag color="orange">dev</Tag>
            <Text strong> Docker Development</Text>
            <Paragraph style={{ marginTop: 8 }}>
              • Gunicorn WSGI Server
              <br />• Containerisierte Umgebung
              <br />• Database Persistence
              <br />
            </Paragraph>
          </div>

          <div>
            <Tag color="green">main</Tag>
            <Text strong> Production</Text>
            <Paragraph style={{ marginTop: 8 }}>
              • Gunicorn WSGI Server
              <br />• Containerisierte Umgebung
              <br />• Database Persistence
              <br />• Traefik Reverse Proxy
              <br />• Automatisches HTTPS (Let&apos;s Encrypt)
              <br />• Security Headers & Health Checks
            </Paragraph>
          </div>
        </Space>
      </Card>

      <Card title="📖 API Documentation">
        <Paragraph>Die vollständige API-Dokumentation ist verfügbar über Swagger UI:</Paragraph>
        <Paragraph>
          <Link href={getSwaggerUrl()} target="_blank" strong>
            {getSwaggerUrl()} →
          </Link>
        </Paragraph>
        <Paragraph type="secondary" style={{ fontSize: "12px" }}>
          Automatisch generiert mit Flask-Smorest + OpenAPI 3.0
        </Paragraph>
      </Card>

      <Card title="🚀 Features">
        <ul>
          <li>✅ Multi-Environment Setup (local, dev, prod)</li>
          <li>✅ Hot Module Replacement (HMR)</li>
          <li>✅ Auto-generated API Docs (Swagger)</li>
          <li>✅ Database Migrations</li>
          <li>✅ Schema Validation</li>
          <li>✅ CORS Configuration</li>
          <li>✅ Error Boundaries</li>
          <li>✅ Loading States</li>
          <li>✅ Code Formatting (Biome, Ruff)</li>
          <li>✅ Git Hooks (Husky)</li>
          <li>✅ Docker Multi-Stage Build</li>
          <li>✅ Traefik Integration</li>
          <li>✅ SSL/TLS Support</li>
        </ul>
      </Card>

      <Card title="📦 Aktuelles Environment">
        <Space direction="vertical">
          <Text>
            <strong>API URL:</strong> {import.meta.env.VITE_API_URL || "/api"}
          </Text>
          <Text>
            <strong>Mode:</strong> {import.meta.env.MODE}
          </Text>
          <Text>
            <strong>Base URL:</strong> {window.location.origin}
          </Text>
        </Space>
      </Card>
    </Space>
  );
}
